import React, { useState, useEffect } from 'react';

const PingDeviceModal = ({ show, onClose }) => {
  const [pingOption, setPingOption] = useState('pingAll');
  const [selectedDevice, setSelectedDevice] = useState('');
  const [selectedPhase, setSelectedPhase] = useState('');
  const [selectedTransformer, setSelectedTransformer] = useState('');
  const [transformerGroups, setTransformerGroups] = useState([]); // For transformer group options

  const [devices, setDevices] = useState([]); // List of devices for "Ping Device" dropdown
  const [phases] = useState(['A', 'B', 'C']); // Phase options for "Ping by Phase"

  useEffect(() => {
    // Fetch devices if needed (assuming you want to populate the "Ping Device" dropdown)
    fetch("/api/devices")
      .then((res) => res.json())
      .then((data) => setDevices(data))
      .catch((err) => console.error("Failed to load devices", err));

    // Simulate fetching transformer groups from AI (This could come from your models)
    setTransformerGroups([
      'Transformer Group 1', 
      'Transformer Group 2',
      'Transformer Group 3'
    ]);
  }, []);

  const handleSubmit = async () => {
  try {
    const response = await fetch("/api/ping", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        pingOption,
        deviceId: selectedDevice,
        phase: selectedPhase,
        transformer: selectedTransformer
      })
    });

    const result = await response.json();
    if (result.success) {
      alert("✅ Ping sent successfully");
    } else {
      alert("❌ Ping failed");
    }
  } catch (error) {
    console.error("Ping error:", error);
    alert("❌ Error sending ping");
  }

  onClose(); // close modal after sending
};

  if (!show) return null; // Don't render modal if "show" is false

  return (
    <div style={overlayStyles}>
      <div style={modalStyles}>
        <h3>Ping Device</h3>
        <div style={{ marginBottom: '15px' }}>
          <label>Ping Option</label>
          <select value={pingOption} onChange={(e) => setPingOption(e.target.value)} style={selectStyles}>
            <option value="pingAll">Ping All Devices</option>
            <option value="pingDevice">Ping Device</option>
            <option value="pingPhase">Ping by Phase</option>
            <option value="pingTransformer">Ping by Transformer Group</option>
          </select>
        </div>

        {pingOption === 'pingDevice' && (
          <div style={{ marginBottom: '15px' }}>
            <label>Device ID, Meter Number or IMEI</label>
            <select 
              value={selectedDevice} 
              onChange={(e) => setSelectedDevice(e.target.value)} 
              style={selectStyles}
            >
              <option value="">Select Device</option>
              {devices.map((device) => (
                <option key={device.deviceId} value={device.deviceId}>
                  {device.deviceId} - {device.meterNumber || device.meter || device.imei}
                </option>
              ))}
            </select>
          </div>
        )}

        {pingOption === 'pingPhase' && (
          <div style={{ marginBottom: '15px' }}>
            <label>Phase</label>
            <select 
              value={selectedPhase} 
              onChange={(e) => setSelectedPhase(e.target.value)} 
              style={selectStyles}
            >
              <option value="">Select Phase</option>
              {phases.map((phase) => (
                <option key={phase} value={phase}>
                  {phase}
                </option>
              ))}
            </select>
          </div>
        )}

        {pingOption === 'pingTransformer' && (
          <div style={{ marginBottom: '15px' }}>
            <label>Transformer Group</label>
            <select 
              value={selectedTransformer} 
              onChange={(e) => setSelectedTransformer(e.target.value)} 
              style={selectStyles}
            >
              <option value="">Select Transformer Group</option>
              {transformerGroups.map((group) => (
                <option key={group} value={group}>
                  {group}
                </option>
              ))}
            </select>
          </div>
        )}

        <button onClick={handleSubmit} style={buttonStyles}>Send Ping</button>
        <button onClick={onClose} style={closeButtonStyles}>Close</button>
      </div>
    </div>
  );
};

// Styles for Modal and Buttons
const overlayStyles = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyles = {
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '8px',
  minWidth: '300px',
  textAlign: 'center',
};

const selectStyles = {
  width: '100%',
  padding: '10px',
  borderRadius: '4px',
  border: '1px solid #ccc',
  marginBottom: '15px',
};

const buttonStyles = {
  padding: '10px 20px',
  backgroundColor: '#28a745',
  color: '#fff',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
  marginRight: '10px',
};

const closeButtonStyles = {
  padding: '10px 20px',
  backgroundColor: '#dc3545',
  color: '#fff',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
};

export default PingDeviceModal;
